import { Component, OnInit } from '@angular/core';
import { FfvapiService } from 'app/shared/services/ffvApi/ffvapi.service';

@Component({
  selector: 'app-my-licence',
  templateUrl: './my-licence.component.html',
  styleUrls: ['./my-licence.component.scss']
})
export class MyLicenceComponent implements OnInit {

  urlPng: string;
  loading = true;


  constructor(
    private ffvService: FfvapiService,
  ) { }

  ngOnInit(): void {
    this.getLicencePng();
  }

  private getLicencePng(): void {

    this.ffvService.getLicencePng().subscribe(res => {
      let data = 'data:image/png;base64,';
      data += res;
      // this.png = this.sanitizer.bypassSecurityTrustResourceUrl(res.supporT_PDF);
      this.urlPng = data;
      this.loading = false;
      // this.urlPdf = res.supporT_PDF;
    });


  }


}
